<template>
  <q-radio
    v-if="isEnabled"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    :val="val"
    :label="label"
    :disable="disable"
    v-bind="$attrs"
  />
  <div v-else>
    <CuiRadioButton
      v-model="localModelValue"
      :value="val"
      :title="label"
      :disable="disable"
      v-bind="$attrs"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import { useFeatureFlags } from "@/composables/useFeatureFlags";
import { ref, watch } from "vue";

const props = withDefaults(defineProps<{
  modelValue?: any;
  val: any;
  label?: string;
  disable?: boolean;
}>(), {
  modelValue: null,
  val: null,
  label: undefined,
  disable: false
});

defineEmits<{
  "update:modelValue": [value: any];
}>();

const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpRadio");

const localModelValue = ref<any>(props.modelValue);

watch(
  () => props.modelValue,
  (value) => {
    localModelValue.value = value;
  }
);
</script>
